export const displayConsultantExperience = experience => {

    if (!experience) {
        return "";
    }

    if ( experience < 0) {
        return "inconnue";
    }

    return experience.toFixed(1) ;
}

export const displayConsultatLastActiviteSince = lastSince => {

    if (!lastSince) {
        return "0";
    }

    if ( lastSince < 0) {
        return "inconnue";
    }

    return lastSince.toFixed(1) ;
}